// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as ReasonReact from "reason-react/src/ReasonReact.js";
import * as ReactLeaflet from "react-leaflet";
import * as Js_null_undefined from "bs-platform/lib/es6/js_null_undefined.js";

function map(opt, f) {
  if (opt !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(opt)));
  }
  
}

var $$Option = {
  map: map
};

var Default = {
  tileSize: undefined,
  maxZoom: undefined,
  zoomOffset: undefined
};

var OpenStreetMap = {
  tileSize: undefined,
  maxZoom: undefined,
  zoomOffset: undefined,
  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
};

function url($staropt$star, accessToken) {
  var id = $staropt$star !== undefined ? $staropt$star : "mapbox/streets-v11";
  return $$String.concat("", /* :: */[
              "https://api.mapbox.com/styles/v1/",
              /* :: */[
                id,
                /* :: */[
                  "/tiles/{z}/{x}/{y}?access_token=",
                  /* :: */[
                    accessToken,
                    /* [] */0
                  ]
                ]
              ]
            ]);
}

var Mapbox_attribution = "© <a href=\"https://www.mapbox.com/about/maps/\">Mapbox</a> © <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> <strong><a href=\"https://www.mapbox.com/map-feedback/\" target=\"_blank\">Improve this map</a></strong>";

var Mapbox_tileSize = 512;

var Mapbox_maxZoom = 18;

var Mapbox_zoomOffset = -1;

var Mapbox = {
  url: url,
  attribution: Mapbox_attribution,
  tileSize: Mapbox_tileSize,
  maxZoom: Mapbox_maxZoom,
  zoomOffset: Mapbox_zoomOffset
};

var Providers = {
  Default: Default,
  OpenStreetMap: OpenStreetMap,
  Mapbox: Mapbox
};

function make(center, className, scrollWheelZoom, style, zoom, children) {
  var scrollWheelZoom$1;
  if (scrollWheelZoom !== undefined) {
    switch (scrollWheelZoom) {
      case /* Zoom */0 :
          scrollWheelZoom$1 = "true";
          break;
      case /* ZoomCenter */1 :
          scrollWheelZoom$1 = "center";
          break;
      case /* NoZoom */2 :
          scrollWheelZoom$1 = "false";
          break;
      
    }
  } else {
    scrollWheelZoom$1 = undefined;
  }
  return ReasonReact.wrapJsForReason(ReactLeaflet.Map, {
              center: Js_null_undefined.fromOption(center),
              className: Js_null_undefined.fromOption(className),
              scrollWheelZoom: Js_null_undefined.fromOption(scrollWheelZoom$1),
              style: Js_null_undefined.fromOption(style),
              zoom: Js_null_undefined.fromOption(zoom)
            }, children);
}

var $$Map = {
  make: make
};

function make$1(param, attribution, draggable, zIndexOffset, opacity, children) {
  return ReasonReact.wrapJsForReason(ReactLeaflet.Marker, {
              position: {
                lat: param[0],
                lng: param[1]
              },
              attribution: Js_null_undefined.fromOption(attribution),
              draggable: Js_null_undefined.fromOption(draggable),
              zIndexOffset: Js_null_undefined.fromOption(zIndexOffset),
              opacity: Js_null_undefined.fromOption(opacity)
            }, children);
}

var Marker = {
  make: make$1
};

function make$2(attribution, className, onClose, onOpen, position, children) {
  var position$1 = map(position, (function (param) {
          return {
                  lat: param[0],
                  lng: param[1]
                };
        }));
  return ReasonReact.wrapJsForReason(ReactLeaflet.Popup, {
              attribution: Js_null_undefined.fromOption(attribution),
              className: Js_null_undefined.fromOption(className),
              onClose: Js_null_undefined.fromOption(onClose),
              onOpen: Js_null_undefined.fromOption(onOpen),
              position: Js_null_undefined.fromOption(position$1)
            }, children);
}

var Popup = {
  make: make$2
};

function make$3(url, attribution, opacity, zIndex, children) {
  return ReasonReact.wrapJsForReason(ReactLeaflet.TileLayer, {
              url: url,
              attribution: Js_null_undefined.fromOption(attribution),
              opacity: Js_null_undefined.fromOption(opacity),
              zIndex: Js_null_undefined.fromOption(zIndex)
            }, children);
}

var TileLayer = {
  make: make$3
};

export {
  $$Option ,
  Providers ,
  $$Map ,
  Marker ,
  Popup ,
  TileLayer ,
  
}
/* ReasonReact Not a pure module */
